export default __webpack_public_path__ + "static/simple-histogram-a0140c7d2368489fc91ec0c23982c556.png";